import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import DotsLoading from '../../../../../components/dotsLoading';
import ChatHeaderIcon from '../../../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import NoItemFoundPage from '../../../../../components/noItemFoundPage';
import SpinnerLoading from '../../../../../components/SpinnerLoading';
import useGetStoreListOrder from '../../../../../services/hookService/getStoreListOrder/useGetStoreListOrder';
import TabSelector from '../../../../myAccount/my-orders/components/TabSelector';
import MyStoreOrderItem from './components/MyStoreOrderItem';
import {
  MyStoreOrderTabsType,
  storeOrderTabsConfig,
} from './storeOrderTabsConfig';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';

const MyStoreOrders = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tabFromUrl = searchParams.get('tab') as MyStoreOrderTabsType | null;

  const isValidTab = storeOrderTabsConfig.some(tab => tab.key === tabFromUrl);

  const [selectedTab, setSelectedTab] = useState<MyStoreOrderTabsType>(
    isValidTab ? tabFromUrl! : 'pending_approval',
  );

  const {data, loaderRef, isFetchingNextPage, isLoading} =
    useGetStoreListOrder(selectedTab);

  // Collect store orders (NOT flattened)
  const storeOrders =
    data?.flatMap(order =>
      order.store_order.map(storeOrder => ({
        storeOrder,
        parentOrderGuid: order.guid,
      })),
    ) ?? [];

  // sync tab changes to URL and fill out the tab search param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set('tab', selectedTab);

    navigate({search: params.toString()}, {replace: true});
  }, [selectedTab]);

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate('/my-store-info')}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">سفارش‌های ثبت شده</span>
          </div>
        )}
        postComponent={() => (
          <div className="flex gap-3 ">
            <NotificationHeaderIcon />
            <ChatHeaderIcon />
          </div>
        )}
      />

      {/* Page Content */}
      <div className="flex flex-col w-full h-full gap-3 px-6 py-3 overflow-y-auto">
        <TabSelector
          tabsConfig={storeOrderTabsConfig}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />

        {isLoading && (
          <div className="flex items-center justify-center h-screen">
            <SpinnerLoading size={40} />
          </div>
        )}

        {!isLoading && !storeOrders.length && <NoItemFoundPage />}

        {!isLoading &&
          storeOrders.map(({storeOrder, parentOrderGuid}) => (
            <MyStoreOrderItem
              key={storeOrder.guid}
              storeOrder={storeOrder}
              parentOrderGuid={parentOrderGuid}
              selectedTab={selectedTab}
            />
          ))}

        <div ref={loaderRef} className="mt-4 text-center">
          {isFetchingNextPage ? <DotsLoading /> : null}
        </div>
      </div>
      <MainFooter />
    </div>
  );
};

export default MyStoreOrders;
